import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';

export default function AdminDashboard() {
  const navigate = useNavigate();

  const tabs = [
    { name: 'Banners', path: 'banners' },
    { name: 'Courses', path: 'courses' },
    { name: 'Results', path: 'results' },
    { name: 'Testimonials', path: 'testimonials' },
  ];

  const logout = () => {
    localStorage.removeItem('adminToken');
    navigate('/admin');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      {/* Sidebar */}
      <aside className="w-64 bg-white shadow-lg p-6 flex flex-col justify-between">
        <div>
          <h2 className="text-xl font-bold mb-6">Admin Panel</h2>
          <nav className="space-y-3">
            {tabs.map((t) => (
              <NavLink
                key={t.path}
                to={t.path}
                className={({ isActive }) =>
                  `block px-4 py-2 rounded-lg ${
                    isActive ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`
                }
              >
                {t.name}
              </NavLink>
            ))}
          </nav>
        </div>

        {/* Logout */}
        <button
          onClick={logout}
          className="w-full mt-6 bg-red-600 text-white py-2 rounded-lg font-semibold hover:bg-red-700 transition"
        >
          Logout
        </button>
      </aside>

      {/* Content */}
      <main className="flex-1 p-8">
        <Outlet />
      </main>
    </div>
  );
}